var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_56)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.57203H6.79115C6.67485 14.5723 5.27145 15.1399 3.50794 15.3045L2.82815 15.3896V20.8865L3.61187 20.8439C5.91529 20.7128 8.45972 20.2939 10.1581 18.1764C11.6469 16.3198 12.3031 13.2862 12.3031 8.62986V0H0V9.57203Z",
    fill: "#030870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6969 0V9.57203H22.3976C22.2813 14.5723 20.9229 15.1399 19.1599 15.3045L18.5251 15.3896V20.8865L19.2633 20.8439C21.5667 20.7128 24.1336 20.2939 25.832 18.1764C27.3208 16.3198 27.9994 13.2862 27.9994 8.62986V0H15.6969Z",
    fill: "#030870"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerQuotes);
export default __webpack_public_path__ + "static/media/lower-quotes.e0fab8caf69baf574d1e3ce4df99e0d6.svg";
export { ForwardRef as ReactComponent };